import React from "react";
import { Badge } from "reactstrap";
import { translate } from "../../../../utils/i18n";
import serviceDueDateChecker from "../../../../utils/serviceDueDateChecker";

const ServiceOrderStatusBadge = (props) => {
  const { status, dueDate, completedAt } = props;

  const statusBageFactory = {
    sos_new: "warning",
    sos_in_progress: "primary",
    sos_completed: "success",
    sos_failed: "danger",
    sos_archived: "secondary",
  };

  return (
    <Badge
      className={`text-capitalize px-3 font-weight-normal text-wrap text-center border border-${
        serviceDueDateChecker({ dueDate, completedAt }) ? "danger" : statusBageFactory[status.slug]
      }`}
      color={"slug" in status && status.slug && statusBageFactory[status.slug]}
      pill
    >
      {"slug" in status ? translate(`${status.slug}`) : "name" in status ? status.name : translate("sos_unknown")}
    </Badge>
  );
};

export default ServiceOrderStatusBadge;
